import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface Props {
  onScan: (code: string) => void;
  onClose: () => void;
}

const CONTAINER_ID = "qr-reader-sell";

export default function QrCodeScanner({ onScan, onClose }: Props) {
  const onScanRef = useRef(onScan);
  const onCloseRef = useRef(onClose);
  onScanRef.current = onScan;
  onCloseRef.current = onClose;

  useEffect(() => {
    const scanner = new Html5Qrcode(CONTAINER_ID);
    let running = false;

    scanner
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 250, height: 250 } },
        (decoded) => {
          const raw = decoded.trim();
          if (!raw) return;
          running = false;
          scanner.stop().catch(() => {});
          onScanRef.current(raw);
        },
        undefined,
      )
      .then(() => { running = true; })
      .catch((err) => { console.error("QR scanner error:", err); });

    return () => {
      if (running) {
        scanner.stop().catch(() => {});
      } else {
        // still initializing — stop when ready
        setTimeout(() => scanner.stop().catch(() => {}), 500);
      }
    };
  }, []); // starts once; callbacks via ref

  return (
    <div className="space-y-4">
      <div id={CONTAINER_ID} className="rounded-lg w-full" />
      <Button variant="outline" className="w-full gap-2" onClick={() => onCloseRef.current()}>
        <X className="h-4 w-4" />
        Fechar câmera
      </Button>
    </div>
  );
}
